



















































































































































































// Vue
import { computed, defineComponent, PropType, onMounted } from '@vue/composition-api'

// models
import { TaskSheetItem } from '@/models/taskSheet'

// components
import { InputTime, TextArea, SwitchToggle, SwitchToggleajeno } from '@/components/form'
import { Select, Input } from '@/components/general'

// utils
import { subtractTime, msToHours, dateLibs, subtractTimeToDate, formatAmount, alerts } from '@/utils'
import { getOnlyHourAndMinute } from '@/utils/dateLibs'

// constants
import { CONDITIONS, ATTEND, ABSENT, optionsWorkType, AMOUNT_LUNCH_TYPES } from '@/constants'
import { LIMIT_TIME_DAY } from '@/constants/taskSheetConstants'
import { FILTERS_ASSISTANCE_DEFAULT } from '@/constants/assistancesConstants'

// services
import { AssistanceService } from '@/services/assistance'

export default defineComponent({
  name: 'TaskItemTr',
  components: {
    InputTime,
    TextArea,
    SwitchToggle,
    SwitchToggleajeno,
    Select,
    Input
  },
  props: {
    headers: {
      required: true,
      type: Array as PropType<{ text: string; key: keyof TaskSheetItem }[]>
    },
    num: {
      required: true,
      type: Number as PropType<number>
    },
    item: {
      required: true,
      type: Object as PropType<TaskSheetItem>
    },
    workType: {
      required: false,
      type: Number as PropType<number>
    },
    nameCollapse: {
      required: true,
      type: String as PropType<string>
    },
    date: {
      required: true,
      type: String as PropType<string>
    },
    isSunday: {
      type: Boolean,
      default: false
    },
    isHoliday: {
      type: Boolean,
      default: true
    },
    actionForm: {
      type: String as PropType<'save'|'update'>
    }
  },
  setup (props) {
    const LIMIT_TIME_NOCTURNAL = subtractTimeToDate(LIMIT_TIME_DAY)
    const MIN_TIME_DAY = subtractTimeToDate('05:30:00')
    const textPermission = () => {
      let text = 'Posee permisos:<br/>'
      props.item.permissions.forEach(p => {
        text += `Desde: ${dateLibs.formatDateOfApi(p.date_start)} - Hasta: ${dateLibs.formatDateOfApi(p.date_end)}<br/>`
        text += `Motivo: (${p.reason.abbreviated}) ${p.reason.description}<br/>`
      })
      return text
    }

    const textCondition = computed(() => {
      let html = ''
      console.log(props.item)
      if (props.item.feriado) {
        html = `${html}<br/><b>FERIADO</b>`
      } else if (props.item.hasPermission) {
        html = textPermission()
      } else if (props.item.timeIn && props.item.timeOut) {
        props.item.condition = ATTEND
        html = CONDITIONS.find(c => c.value === ATTEND)?.text ?? ''
      } else if (!props.item.timeIn && !props.item.timeOut && !props.isSunday) {
        props.item.condition = ABSENT
        html = CONDITIONS.find(c => c.value === ABSENT)?.text ?? ''
      } else if (props.isSunday) {
        html = `${html}<br/><b>DOMINGO</b>`
      }
      return html
    })

    const textWorkType = computed(() => {
      return optionsWorkType.find(op => op.value === props.workType)?.text ?? ''
    })

    const textWorkTypeById = (workType: number) => {
      return optionsWorkType.find(op => op.value === workType)?.text ?? ''
    }

    const getTotalWorking = computed(() => {
      const dateTimeIn = subtractTimeToDate(props.item.timeIn)
      let dateTimeOut = subtractTimeToDate(props.item.timeOut)
      let total = 0
      if (dateTimeOut && dateTimeIn) {
        if (!(dateTimeOut >= dateTimeIn)) {
          dateTimeOut = subtractTimeToDate(props.item.timeOut, true)
        }
        // @ts-ignore
        total = msToHours(dateTimeOut - dateTimeIn)
      }

      if (total >= 8) {
        total = total - props.item.timeLunch
      }
      props.item.timeWorkingTotal = total
      return Number(total.toFixed(2))
    })

    // Calculate time hours real.
    const getTotalDReal = () => {
      let total = 0
      const dateTimeIn = subtractTimeToDate(props.item.timeInDevice)
      const dateTimeOut = subtractTimeToDate(props.item.timeOutDevice)
      if (dateTimeIn && dateTimeOut && LIMIT_TIME_NOCTURNAL && MIN_TIME_DAY) {
        if (dateTimeIn >= MIN_TIME_DAY && dateTimeOut > dateTimeIn && dateTimeOut <= LIMIT_TIME_NOCTURNAL) {
          total = msToHours(subtractTime(props.item.timeInDevice, props.item.timeOutDevice))
        } else {
          total = msToHours(subtractTime(props.item.timeInDevice, LIMIT_TIME_DAY))
        }
      }
      return Number(formatAmount(total))
    }

    const getTotalD = () => {
      let total = 0
      const dateTimeIn = subtractTimeToDate(props.item.timeIn)
      const dateTimeOut = subtractTimeToDate(props.item.timeOut)
      if (dateTimeIn && dateTimeOut && LIMIT_TIME_NOCTURNAL && MIN_TIME_DAY) {
        if (dateTimeIn >= MIN_TIME_DAY && dateTimeOut > dateTimeIn && dateTimeOut <= LIMIT_TIME_NOCTURNAL) {
          total = msToHours(subtractTime(props.item.timeIn, props.item.timeOut))
        } else {
          total = msToHours(subtractTime(props.item.timeIn, LIMIT_TIME_DAY))
        }
      }
      return Number(formatAmount(total))
    }

    const getTotalDay = () => {
      const total = getTotalD()
      if (total > 8) {
        return 8
      }
      return Number(formatAmount(total))
    }

    const getTotalDay2 = () => {
      const total = getTotalD()
      return Number(formatAmount(total))
    }

    const getExtraDayTotal = (withAcumulative = false) => {
      const extra = getTotalD() - 8
      if (extra > 0 && !withAcumulative) {
        return Number(formatAmount(extra))
      }
      return 0
    }

    const getExtraDay25 = () => {
      const extra = getExtraDayTotal(props.item.workShift.isCumulative)
      if (extra > 2) {
        return 2
      }
      return Number(formatAmount(extra))
    }

   const getExtraDay35 = () => {
      return Number(formatAmount(getExtraDayTotal(props.item.workShift.isCumulative) - getExtraDay25()))
   }

   const getTotalNocturnal = computed(() => {
     let total = 0
      const dateTimeIn = subtractTimeToDate(props.item.timeIn)
      let dateTimeOut = subtractTimeToDate(props.item.timeOut)
      // @ts-ignore
      if (dateTimeOut < dateTimeIn) {
        dateTimeOut = subtractTimeToDate(props.item.timeOut, true)
      }
      if (dateTimeOut && LIMIT_TIME_NOCTURNAL) {
        // @ts-ignore
        total = msToHours(dateTimeOut - LIMIT_TIME_NOCTURNAL)
      }
      return total > 0 ? Number(formatAmount(total)) : 0
    })

    const getTotalN = () => {
      const total = getTotalNocturnal.value
      if (total > 8) {
        return 8
      }
      return Number(formatAmount(total))
    }

    const getExtraNocturnalTotal = (withAcumulative = false) => {
      const extra = getTotalNocturnal.value - 8
      if (extra > 0 && !withAcumulative) {
        return Number(formatAmount(extra))
      }
      return 0
    }

    const getExtraNocturnal25 = () => {
      const extra = getExtraNocturnalTotal(props.item.workShift.isCumulative)
      if (extra > 2) {
        return 2
      }
      return Number(formatAmount(extra))
    }

    const getExtraNocturnal35 = () => {
      return Number(formatAmount(getExtraNocturnalTotal(props.item.workShift.isCumulative) - getExtraNocturnal25()))
    }

    const getCumulativeHoursTotal = computed(() => {
      return Number(formatAmount(getExtraDayTotal() + getExtraNocturnalTotal()))
    })

    const calculateJornales = (item: TaskSheetItem) => {
      console.log('aqui se aplico un cambio : horas' + item.timeTotal + ' y el salario diario : ' + item.employeeBaseSalary)
      if (item.timeTotal > 0) {
        item.amounts = (parseFloat(item.employeeBaseSalary) / 30 / 8) * parseFloat(item.timeTotal)
      } else {
        item.amounts = 0
      }
    }

    const calculateTime = () => {
      props.item.timeWorkingTotal = getTotalWorking.value
      setTimeout(() => {
        if (props.item.workType === 2) {
          props.item.timeTotal = getTotalDay2()
            if (props.item.timeTotal >= 8.5) {
              props.item.timeTotal = props.item.timeTotal - 1.5
            }
        } else {
          props.item.timeTotal = getTotalDay()
        }
        // props.item.timeExtra25 = getExtraDay25()
        // props.item.timeExtra35 = getExtraDay35()
        props.item.timeTotalN = getTotalN()
        props.item.timeExtra25N = getExtraNocturnal25()
        props.item.timeExtra35N = getExtraNocturnal35()
        setTimeout(() => {
          if (props.item.workShift.isCumulative) {
            props.item.cumulativeHoursDay = getCumulativeHoursTotal.value
          }
          if (props.item.workType === 1) {
            calculateJornales(props.item)
          }
        }, 500)
      }, 200)
    }

    const handleChangeLunchCheck = () => {
      let timeTotalReal = getTotalDReal()
      if (props.item.lunch) {
        timeTotalReal = timeTotalReal - props.item.timeLunch
      }
      props.item.timeTotalReal = timeTotalReal <= 0 ? 0 : timeTotalReal
    }

    onMounted(() => {
      calculateTime()
      if (props.actionForm && props.actionForm === 'save') {
        handleChangeLunchCheck()
      }
      // console.log(props.item.timeIn)
      console.log('dos ' + props.item.timeOut)
      if (props.item.timeIn !== '' && props.item.timeOut !== '' && props.item.timeTotalReal <= 0) {
        if (props.item.timeIn !== props.item.timeOut && props.item.timeTotalReal <= 0) {
          props.item.timeTotalReal = 8
        }
      }
    })

    const viewWorkDescription = () => {
      props.item.viewWorkDescription = !props.item.viewWorkDescription
    }

    const feriado = () => {
      props.item.feriado = !props.item.feriado
    }

    const updateTimeByEmployee = async (employeeId: number) => {
      const confirm = await alerts.confirm('Seguro que desea continuar con la operación?')
      if (confirm) {
        const assistanceEmployee = await AssistanceService.getAll({
          ...FILTERS_ASSISTANCE_DEFAULT,
          employeeId: employeeId,
          dateStart: props.date,
          dateEnd: props.date
        })
        if (assistanceEmployee && assistanceEmployee.length > 0) {
          alerts.success()
          const assistance = assistanceEmployee[0]
          props.item.timeInDevice = getOnlyHourAndMinute(assistance.checkin_time)
          props.item.timeOutDevice = getOnlyHourAndMinute(assistance.checkout_time)
          props.item.timeIn = getOnlyHourAndMinute(assistance.checkin_time)
          props.item.timeOut = getOnlyHourAndMinute(assistance.checkout_time)
        } else {
          alerts.info('El empleado no posee registros de assistencia para la fecha: ' + props.date)
        }
      }
    }

    const changeWorkTypeItem = (value: boolean, item: TaskSheetItem) => {
      item.workType = value ? 1 : 0
      if (value) {
        calculateJornales(item)
      } else {
        item.amounts = item.dailyControls.reduce((total, current) => total + current.total, 0)
      }
    }

    return {
      textCondition,
      textWorkType,
      viewWorkDescription,
      feriado,
      calculateTime,
      textWorkTypeById,
      updateTimeByEmployee,
      AMOUNT_LUNCH_TYPES,
      calculateJornales,
      changeWorkTypeItem,
      handleChangeLunchCheck
    }
  }
})
